<template>
  <div class="modal-parent">
    <div class="gala">
      <main class="gala-container">
        <!-- BANNER -->
      <div class="gala-banner" data-v-b983b090="">
        <div class="gala-banner-content">
            <img src="../../assets/vecinos-al-limite/images/val_logo.png" alt="Banner Logo" class="gala-banner-logo" data-v-b983b090="">
            <h4 class="text-white banner-monto">¡Tú eliges al cuarto finalista de Vecinos al Límite!</h4>
            <span class="banner-premio">Y PARTICIPA POR $300.000</span>
        </div>
    </div>
        <!-- GRILLA -->
        <div class="gala-grid">
          <div class="vecinos-card" v-for="(item, i) in jsonData" :key="i">
            <div class="vecinos-card-foto cursor-pointer" @click="sendDataForModal(item.nombre)">
              <p class="vecinos-card-nombre">{{ nombreVisible(item.nombre) }}</p>
              <img :src="fotoParticipante(item)" alt="Foto participante" />
            </div>
            <button class="vecinos-card-votar" @click="sendDataForModal(item.nombre)">VOTAR</button>
          </div>
        </div>
        <!-- PENDIENTE: URL definitiva de bases (canal 13). Placeholder generico. -->
        <div class="banner-bases">
          <a href="https://www.13.cl/concursos" target="_blank" rel="noopener noreferrer">Bases y ganador en 13.cl</a>
          - sms 590 iva incl - bolsas de votos desde $1.990 iva incl
        </div>
      </main>

      <footer>
        <div>
          <p>Desarrollado por</p>
          <a href="mailto:contacto@celcom.cl" target="_blank">
            <img src="../../assets/galeria/logo_celcom_blanco.svg" alt="Logo Celcomlatam blanco"/>
          </a>
        </div>
      </footer>
      <div class="row justify-content-center">
        <div class="col-xl-8 text-center p-0">
          <div v-if="jsonData && !hayParticipantesActivos" class="got-votacion justify-content-center text-white text-uppercase">
            <h1 class="py-5 display-1">¡Votaciones Cerradas!</h1>
          </div>
          <div v-else class="gh-votacion justify-content-center text-white text-uppercase"/>
        </div>
      </div>
    </div>
    <ModalVotacionVecinosAlLimite
      v-if="modaIsActive"
      :dataForVotes="dataForVotes"
      :foto="dataForVotes.nombre ? fotoParticipante(dataForVotes) : ''"
      :modaIsActive="modaIsActive"
      @changeModalIsActive="changeModalIsActive"
    />
    <LoaderComponent v-if="loaderIsActive"/>
  </div>
</template>

<script>
import ModalVotacionVecinosAlLimite from "./ModalVotacionVecinosAlLimite.vue";
import axios from "axios";
import { logout } from '@/auth.js';
import LoaderComponent from "../LoaderComponent/LoaderComponent.vue";

// Orden y fotos recortadas (cabeza y hombros) segun la propuesta de Canal 13.
// Si llega un participante que no esta aqui, se usa el imageLink del backend.
const ORDEN = ['LISANDRA', 'CAROLINA', 'NABILA', 'PAULA', 'JOCHE', 'MATIAS'];
const FOTOS = {
  LISANDRA: require('@/assets/vecinos-al-limite/images/participantes/lisandra.png'),
  CAROLINA: require('@/assets/vecinos-al-limite/images/participantes/carolina.png'),
  NABILA: require('@/assets/vecinos-al-limite/images/participantes/nabila.png'),
  PAULA: require('@/assets/vecinos-al-limite/images/participantes/paula.png'),
  JOCHE: require('@/assets/vecinos-al-limite/images/participantes/joche.png'),
  MATIAS: require('@/assets/vecinos-al-limite/images/participantes/matias.png'),
};
const NOMBRES = { MATIAS: 'Matías' };
const posicion = nombre => {
  const i = ORDEN.indexOf(nombre);
  return i === -1 ? ORDEN.length : i;
};

export default {
  name: 'VecinosAlLimiteView',
  components: {
    ModalVotacionVecinosAlLimite,
    LoaderComponent
  },
  data() {
    return {
      jsonData: null,
      dataForVotes: {},
      modaIsActive: false,
      loaderIsActive: true,
    };
  },
  computed: {
    hayParticipantesActivos() {
      return this.jsonData.some(item => item.active);
    },
  },
  methods: {
    sendDataForModal(name){
      this.dataForVotes = {};
      this.modaIsActive = true;
      setTimeout(() => {
        const selectedItem = this.jsonData.find(item => item.nombre === name);
        this.dataForVotes = selectedItem;
      }, 10);
    },
    async cargarData() {
      // lp/6 es exclusivo de Vecinos al Limite (category VECINOS), basta filtrar por `active`.
      await axios.get("https://automata2.celcom.cl/lp_tvi_backend/api/notification/participantes_general/lp/6")
        .then(response => {
          this.jsonData = response.data.filter(item => item.active)
                .sort((a, b) => posicion(a.nombre) - posicion(b.nombre) || a.nombre.localeCompare(b.nombre));
        })
        .finally(() => {
          this.loaderIsActive = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
    fotoParticipante(item) {
      return FOTOS[item.nombre] || item.imageLink;
    },
    nombreVisible(nombre) {
      return NOMBRES[nombre] || nombre.charAt(0) + nombre.slice(1).toLowerCase();
    },
    changeModalIsActive(value) {
      this.modaIsActive = value;
    },
  },
  created() {
    logout();
  },
  async mounted() {
    await this.cargarData();
    if (this.$route.params.name) {
      this.sendDataForModal(this.$route.params.name);
    }
  },
}
</script>
<style scoped lang="scss">
@font-face {
  font-family: 'avenir-regular';
  src: url('../../assets/vecinos-al-limite/fonts/SourceSansPro-Regular.ttf');
}

@font-face {
  font-family: 'avenir-bold';
  src: url('../../assets/vecinos-al-limite/fonts/SourceSansPro-Black.ttf');
}

.text-gold-miss {
    color: #B49B57;
}

.gala-banner-content {
    text-align: center;
    padding: 40px 0;
}
.gala-banner-logo {
    position: initial;
    width: 360px;
    max-width: 92%;
}
.banner-monto {
    font-family: 'avenir-bold';
    margin-top: 20px;
    margin-bottom: 10px;
    line-height: 1.3;
    /* h4 de bootstrap + 2pt (~2,7px), pedido de Canal 13 para que se lea como titular */
    font-size: calc(1.44rem + .3vw);
}
@media (min-width: 1200px) {
    .banner-monto {
        font-size: 1.67rem;
    }
}
/* destacados amarillos del arte de Vecinos al Limite */
.banner-premio,
.banner-bases {
    background-color: #ffc93c;
    color: #111;
    font-family: 'avenir-bold';
}
.banner-premio {
    display: inline-block;
    padding: 4px 14px;
    font-size: 1.6rem;
    line-height: 1.2;
}
.banner-bases {
    margin: 8px 16px 24px;
    padding: 6px 12px;
    font-size: 14px;
    text-align: center;

    a {
        color: inherit;
        text-decoration: underline;
    }
}
@media (max-width:768px) {
    .banner-premio {
        font-size: 1.25rem;
    }
}
.text-green-miss {
    color: #0DB7B2;
}
@media (max-width:768px) {
    .gala-banner {
        height: initial;
    }
}
.gala{
  background-image: url('../../assets/vecinos-al-limite/images/val_back.jpg');
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  /* azul del cielo, de respaldo mientras descarga la imagen de fondo */
  background-color: #0b2a45;
  font-family: 'avenir-regular';
  min-height: 100vh;
  padding-bottom: 110px;
  position: relative;

  p{
    margin: 0;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  &-banner{
    position: relative;

    &-logo{
      top: 50%;
      left: 50%;
      width: 360px;
      max-width: 92%;
    }

    &-text{
      background-color: #000;
      color: #FFF;
      text-align: center;
      padding: 8px 16px;
      font-size: 14px;
    }
  }

  footer{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    color: #FFF;
    padding: 8px 0;
    font-size: 14px;
    text-align: center;

    a{
      text-decoration: underline;
    }

    div{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      a{
        text-decoration: none;

        img{
          margin-top: -4px;
          width: 70px;
        }
      }
    }
  }
}
@media (max-width:768px) {
    .gala-banner {
        height: initial;
    }
    .gala{
      background-image: url("../../assets/vecinos-al-limite/images/val_back.jpg");
      background-position: center bottom;
      background-size: cover;
      background-repeat: no-repeat;
      padding-bottom: 80px;
    }
}
.gala-container {
  width: 100%;
  margin: 0 auto;

  // Tamaño por defecto (Mobile)
  max-width: 480px;

  // Tablet
  @media (min-width: 481px) {
    max-width: 640px;
  }

  // Desktop
  @media (min-width: 1024px) {
    max-width: 960px;
  }
}

.gala-grid {
  padding: 16px;
  display: grid;
  gap: 20px 16px;

  // 2 columnas en movil; desde tablet 3, para que 6 participantes queden 3 y 3
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 481px) {
    grid-template-columns: repeat(3, 1fr);
    max-width: 720px;
    margin: 0 auto;
  }
}
/* tarjeta segun la propuesta: fondo dorado, nombre arriba, foto abajo y boton amarillo bajo la tarjeta */
.vecinos-card {
  display: flex;
  flex-direction: column;
  align-items: center;

  &-foto {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    /* degradado dorado enviado por Canal 13 ("fondo personajes") */
    background: #c4a477 url('../../assets/vecinos-al-limite/images/val_personajes.jpg') center / cover no-repeat;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .3);
    overflow: hidden;

    img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 82%;
      object-fit: cover;
      object-position: center top;
    }
  }

  &-nombre {
    position: relative;
    z-index: 1;
    padding-top: 6px;
    text-align: center;
    font-family: 'avenir-bold';
    font-size: 1.5rem;
    line-height: 1.2;
    color: #1d2a33;
  }

  &-votar {
    margin-top: 10px;
    width: 80%;
    border: none;
    border-radius: 999px;
    background-color: #ffc93c;
    color: #111;
    font-family: 'avenir-bold';
    font-size: 1.1rem;
    letter-spacing: .5px;
    padding: 4px 0;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .3);
  }
}
@media (max-width: 480px) {
  .vecinos-card-nombre {
    font-size: 1.2rem;
  }
}
.modal-parent{
  overflow: hidden;
}
.gala-chv-logo {
    display: block;
    margin: 0 auto;
    padding: 30px;
    width: 250px;
}
</style>
